import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { VendaFormaPag } from 'src/app/models/venda-forma-pag';
import swal from 'sweetalert2';
import { CadastrarMultiFormaPagamentoModalComponent } from './cadastrar-multi-forma-pagamento-modal/cadastrar-multi-forma-pagamento-modal.component';

declare const $: any;

@Component({
  selector: 'app-multi-forma-pagamento-modal',
  templateUrl: './multi-forma-pagamento-modal.component.html',
  styleUrls: ['./multi-forma-pagamento-modal.component.scss']
})
export class MultiFormaPagamentoModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  formasPagamentoMulti: VendaFormaPag[] = [];
  valorSubTotalPedido = 0;
  valorPedido = 0;
  valorFormasPagamento = 0;
  editavel = true;
  naoExibirTotais = false;
  pCentroDistribuicao = false;
  pMultiFornecedor = false;
  idCD;

  alterou = false;
  public MASKS = MASKS;


  constructor(public dialogRef: MatDialogRef<MultiFormaPagamentoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog,) {

    this.formasPagamentoMulti = data.formasPagamentoMulti !== undefined && data.formasPagamentoMulti !== null ? data.formasPagamentoMulti : this.formasPagamentoMulti;
    this.valorSubTotalPedido = data.valorSubTotalPedido;
    this.valorPedido = data.valorPedido;
    this.editavel = data.editavel;
    this.naoExibirTotais = data.naoExibirTotais;
    this.pCentroDistribuicao = data.pCentroDistribuicao;
    this.pMultiFornecedor = data.pMultiFornecedor;
    this.idCD = data.idCD;
  }

  ngOnInit() {
    this.atualizarValorFormas();
  }

  novaFormaPagamento() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarMultiFormaPagamentoModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card',
      data: {
        forma: new VendaFormaPag(),
        valorSubTotalPedido: this.valorSubTotalPedido,
        pCentroDistribuicao: this.pCentroDistribuicao,
        pMultiFornecedor: this.pMultiFornecedor,
        idCD: this.idCD
      }
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) return;

      this.alterou = true;

      res.valor = Number(res.valor);
      this.formasPagamentoMulti.push(res);
      this.atualizarValorFormas();
    });
  }

  editarFormaPagamento(forma: VendaFormaPag) {
    const formaParaEditar = Object.assign({}, forma);
    formaParaEditar.valor = Number(formaParaEditar.valor);
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(CadastrarMultiFormaPagamentoModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      data: {
        forma: formaParaEditar,
        pCentroDistribuicao: this.pCentroDistribuicao,
        pMultiFornecedor: this.pMultiFornecedor,
        idCD: this.idCD
      },
      panelClass: 'modal-card'
    });



    dialogRef.afterClosed().subscribe((res: VendaFormaPag) => {
      if (!res) return;

      forma.descricaoCondPag = res.descricaoCondPag;
      forma.descricaoFormaPag = res.descricaoFormaPag;
      forma.idCondPag = res.idCondPag;
      forma.idFormaPag = res.idFormaPag;
      forma.idCupom = res.idCupom;
      forma.valor = Number(res.valor);
      this.alterou = true;

      this.atualizarValorFormas();

    });
  }

  excluirFormaPagamento(item: VendaFormaPag) {
    swal({
      title: 'Deseja realmente Excluir a Forma de Pagamento ?',
      text: '',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false,
      type: 'warning'
    }).then((result) => {
      if (result.value) {
        this.formasPagamentoMulti.splice(this.formasPagamentoMulti.indexOf(item), 1);
        this.atualizarValorFormas();
        this.alterou = true;
      }
    });
  }

  atualizarValorFormas() {
    this.valorFormasPagamento = this.formasPagamentoMulti.reduce((acc, curr) => acc += Number(curr.valor), 0);
  }

  fechar() {
    this.dialogRef.close();
  }

  salvar() {
    this.dialogRef.close({ formasPagamento: this.formasPagamentoMulti, alterou: this.alterou });
  }

  ordena(campo) {
    return false;
  }

}
